import ApiResourceManager from '../ApiResourceManager';

export default class ServiceFeeSettingsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/service-fee-settings',
    });

  update = (data) =>
    this.request({
      method: 'PUT',
      url: '/service-fee-settings',
      data,
    });

  /** "Charge the service fee on table orders": true / false, or null to follow the partner. */
  updateOnSite = (chargesOnSite) =>
    this.request({
      method: 'PUT',
      url: '/service-fee-settings/on-site',
      data: { charges_on_site: chargesOnSite },
    });

  remove = () =>
    this.request({
      method: 'DELETE',
      url: '/service-fee-settings',
    });
}
